import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import EnterpriseOrgScopedPageDataProvider from 'bundles/unified-common/providers/org-scoped/data/EnterpriseOrgScopedPageDataProvider';
import EnterpriseOrgUserExperienceHandler from 'bundles/unified-common/providers/org-scoped/data/EnterpriseOrgUserExperienceHandler';
import EnterpriseOrgScopedHeaderFooterWrapper from 'bundles/unified-common/providers/org-scoped/layout/EnterpriseOrgScopedHeaderFooterWrapper';
import EnterpriseOrgScopedModalManagerProvider from 'bundles/unified-common/providers/org-scoped/modals/EnterpriseOrgScopedModalManagerProvider';

// The reviews stylesheet ('css!bundles/reviews/styl/index') is loaded via ReviewsApp — which routes.tsx
// also imports — so it does not need to be re-imported here (and avoids a new css! loader anti-pattern).
const EnterpriseOrgScopedReviewsApp = ({ children }: React.PropsWithChildren) => {
  return (
    <div className="rc-ReviewsApp">
      <EnterpriseOrgScopedPageDataProvider>
        <EnterpriseOrgUserExperienceHandler>
          <EnterpriseOrgScopedModalManagerProvider>
            <EnterpriseOrgScopedHeaderFooterWrapper hideAdminImpersonationBanner>
              {children}
            </EnterpriseOrgScopedHeaderFooterWrapper>
          </EnterpriseOrgScopedModalManagerProvider>
        </EnterpriseOrgUserExperienceHandler>
      </EnterpriseOrgScopedPageDataProvider>
    </div>
  );
};

export default compose<{}, React.PropsWithChildren>(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'reviews',
      page: 'reviews',
    },
  }))
)(EnterpriseOrgScopedReviewsApp);
